// formSource.js
export const userInputs = [
  
  {
    id: 2,
    label: "Username",
    type: "text",
    name: "username",
    placeholder: "johndoe",
  },
  {
    id: 3,
    label: "Name & Surname",
    type: "text",
    name: "name",
    placeholder: "John Doe",
  },
  {
    id: 4,
    label: "Email",
    type: "email",
    name: "email",
    placeholder: "john@example.com",
  },
  {
    id: 5,
    label: "Phone",
    type: "tel",
    name: "phone",
    placeholder: "+91 99999-99999",
  },
  {
    id: 6,
    label: "Password",
    type: "password",
    name: "password",
    placeholder: "••••••••",
  },
  {
    id: 7,
    label: "Address",
    type: "text",
    name: "address",
    placeholder: "123 Main St",
  },
  {
    id: 8,
    label: "Country",
    type: "text",
    name: "country",
    placeholder: "India",
  },
];



export const productInputs = [
 
  {
    id: 1,
    label: "Product Name",
    type: "text",
    name: "productName",
    placeholder: "Lavender Perfume",
  },
  {
    id: 2,
    label: "Category",
    type: "text",
    name: "category",
    placeholder: "Fragrance",
  },
  {
    id: 3,
    label: "Price",
    type: "number",
    name: "price",
    placeholder: "399",
  },
  {
    id: 4,
    label: "Quantity",
    type: "number",
    name: "quantity",
    placeholder: "10",
  },
  {
    id: 5,
    label: "Description",
    type: "text",
    name: "description",
    placeholder: "Long-lasting floral scent with a hint of musk...",
  }
];
